import { useApiBackendInfo } from '@/hooks/query';

export const useWcPromotionEligibility = () => {
	const { isBefore, hasNoDeposit } = useApiBackendInfo();

	return {
		isEligibleForWcInteraction: !isBefore && !hasNoDeposit,
	};
};